import { render, staticRenderFns } from "./PasswordModifier.vue?vue&type=template&id=9ff97848&"
import script from "./PasswordModifier.vue?vue&type=script&lang=js&"
export * from "./PasswordModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports